import {mapGetters} from "vuex";
import LoaderMini from "@/components/LoaderMini/LoaderMini.vue";
import store from "../../store";
export default {
    name: 'PleaseActivate',
    components: {LoaderMini},
    data() {
        return {
            successMessage: false,
            showLoader: false,
            failMessage: false,
            result: false,
        }
    },
    created() {
        this.$store.dispatch('details')
            .then(res => {
               if (this.userInfo && this.userInfo.email_verified_at !== null) {
                   this.$router.push('/my-gates')
               }
            })
    },
    methods: {
        sendMail(answer) {
            if (this.checkFBUser) {
                this.changeData()
            }
            this.showLoader = true
            this.$store.dispatch('sendEmailToActivate').then(res => {
                setTimeout(()=>{this.result = answer},1000)
            })
        },
        validateEmail(email) {
            return email.match(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        },
        changeData() {
            this.userData.email = this.userInfo.email
            this.$store.dispatch('requestToChangeEmail', {mail: this.userData.email}).then((res) => {
                console.log(res)
            })
                .then(() => {
                    console.log('success')
                })
                .catch((err)=>{
                    console.log(err)
                })
        }

    },
    computed: {
        ...mapGetters(['userInfo']),
        checkFBUser() {
            return null
        },
        checkIsEmail() {
            return Boolean(JSON.parse(localStorage.user).email)
        },
        errorEmail() {
            return this.validateEmail(this.userInfo.email)
        },
        userData() {
            return JSON.parse(localStorage.user)
        }
    }
}
